var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPolicies = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 .953c-1.534 0-3.715.52-4.871.815A1.504 1.504 0 0 0 2 3.22v3.232c0 2.475 1.468 4.572 2.889 6.051a16.84 16.84 0 0 0 2.845 2.373l.27.168.266-.172s1.422-.913 2.841-2.402C12.531 10.982 14 8.89 14 6.453V3.221c0-.682-.466-1.283-1.127-1.453h-.002C11.715 1.473 9.534.953 8 .953Zm0 1c1.294 0 3.493.496 4.623.784A.495.495 0 0 1 13 3.22v3.232c0 2.026-1.28 3.933-2.611 5.328-1.197 1.256-2.163 1.874-2.39 2.026-.229-.149-1.192-.75-2.388-1.994C4.282 10.429 3 8.525 3 6.453V3.221a.49.49 0 0 1 .375-.484c1.13-.288 3.33-.784 4.625-.784Zm3.646 2.272L7.375 8.496 5.104 6.225l-.708.707L7.375 9.91l4.979-4.978-.707-.707Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPolicies);
export default ForwardRef;